<template>
  <div v-if="appId==='standard'">
    <!-- <b-alert show dismissible>
      <h4>新手指南</h4>
      <p >欢迎使用票管家管理您的进项发票和版式文件，您可以通过多种途径采集发票版式文件，并且自动完成发票的查验和审核</p>
      <ol>
        <li>通过您设置的一个公共邮箱接收发票并且进行审核</li>
        <li>在审核记录中，通过上传按钮进行发票审核</li>
        <li>企业通过实名认证后，自动接收来自瑞宏网的电子发票</li>
        <li>通过API接口，将发票数据上传给票管家进行审核</li>
      </ol>
    </b-alert> -->

    <b-card bg-variant="dark" text-variant="white" title="邮箱设置" dismissible v-show="(homeDto.mailAccount+'').includes('chinaeinv.net')">
      <b-card-text>
        <span>
          <p>将电子发票版式文件发送到指定的邮箱 {{homeDto.mailAccount}}，从而完成发票的自动验真和审核</p>
          <b-link class="btn btn-primary" v-show="(homeDto.mailAccount+'').includes('chinaeinv.net') " :to="{path:'/settings/mail-account', query:{orgId: homeDto.orgId}}">修改邮箱</b-link>
        </span>
      </b-card-text>
    </b-card>

    <div class="row my-3">
      <div class="col-sm">
        <div class="card border-primary">
          <div class="card-header text-center bg-primary text-white">审核通过</div>
          <div class="card-body">
            <h5 align="center">{{homeDto.checkedCount}}</h5>
          </div>
        </div>
      </div>

      <div class="col-sm">
        <div class="card border-success">
          <div class="card-header text-center bg-success text-white">已入帐</div>
          <div class="card-body">
            <h5 align="center">{{homeDto.accCount}}</h5>
          </div>
        </div>
      </div>

      <div class="col-sm">
        <div class="card border-info">
          <div class="card-header text-center bg-info text-white">公司</div>
          <div class="card-body">
            <h5 align="center">{{homeDto.entCount}}</h5>
          </div>
        </div>
      </div>
      
      <div class="col-sm">
        <div class="card border-danger">
          <div class="card-header text-center bg-danger text-white">审核失败</div>
          <div class="card-body">
            <h5 align="center">{{homeDto.failedCount}}</h5>
          </div>
        </div>
      </div>
    </div>

    <div class="row m-3">
      <div id="myChart" :style="{width: '100%', height: '500px'}"></div>
    </div>
    <loading :show="pageLoading"></loading>

  </div>
</template>

<script>
import * as homeFacade from "../../../api/home-facade.js";
import { mapState } from "vuex";

export default {
  // validations:
  data() {
    return {
      homeDto:{},
      statDtoList:{},
      pageLoading:false,
      appId:"standard"
    };
  },

  created() {},
  computed: {
    ...mapState("admin/user", ["info"])
  },
  mounted() {
    this.appId = this.info.orgId== process.env.VUE_APP_MAERSK_ORG_ID ? "maersk" : "standard";
    this.init()
  },
  methods: {
    init(){
      this.pageLoading = true;
      homeFacade
        .kpi()
        .then(res => {
          this.pageLoading = false;
          this.homeDto = res;
        })
        .catch(err => {
          console.log("err", err);
          this.pageLoading = false;
        });

      // 最近30天统计
      homeFacade
        .daystat()
        .then(res => {
          this.pageLoading = false;
          this.statDtoList = res;
          //console.log(this.statDtoList)
          this.drawLine(res)
        })
        .catch(err => {
          console.log("err", err);
          this.pageLoading = false;
        });
    },


      // 画线
      drawLine(data){
        // 基于准备好的dom，初始化echarts实例
        let myChart = this.$echarts.init(document.getElementById('myChart'))


      //   // 绘制图表
        let option={
          title: {
              left: 'center',
              text: '最近30天审核及入账统计',
          },
          legend: [
              {
                  data: [
                      "审核", 
                      "入账"
                  ], 
                  top: "40"
              }
          ], 
        dataset: [
          {
            source: data
          }
        ],
        "toolbox": {
            "feature": {
                "dataView": {
                    "show": true, 
                    "readOnly": false
                }, 
                "magicType": {
                    "show": true, 
                    "type": [
                        "line", 
                        "bar"
                    ]
                }, 
                "restore": {
                    "show": true
                }, 
                "saveAsImage": {
                    "show": true
                }
            }
        }, 
        "grid": {
            "top": 90, 
            "show": true
        }, 
        "tooltip": {
            "trigger": "axis", 
            "axisPointer": {
                "animation": false
            }
        }, 
        xAxis: [
          {
            type: "category",
            boundaryGap: true
          }
        ],
        yAxis: [
          {
            name: "数量",
            nameLocation: "middle",
            nameGap: 40,
            type: "value"
          }
        ],
        series: [
          {
            name: "审核",
            yAxisIndex: 0,
            type: "bar",
            encode: {
                x: 'dateTime',
                y: ['checkedCount']
            }
          },
          {
            name: "入账",
            yAxisIndex: 0,
            type: "bar",
            encode: {
                x: 'dateTime',
                y: ['accCount']
            }
          }
        ]
      };

        myChart.setOption(option);

      }

  }
};
</script>

<style >
</style>
